import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { isNull } from 'lodash'
import { Link } from 'react-router-dom'
import { parseQsId, parseQsArg, itemLink, getLocationKey } from '../../utils'
import {
  getItemsICanGet,
  canLoadMoreItemsICanGet,
  getItemsICanGetLoading,
  getTotalItemsICanGet,
  isItemsICanGetCacheValid,
  getWorld,
  getCategory,
} from '../../selectors'
import {
  getItemDetail,
  unloadItemDetail,
  loadItemsICanGet,
  loadMoreItemsICanGet,
  unloadItemsICanGet,
  putItemsICanGetInCache,
} from '../../actions'
import ErrorPage from '../../common/ErrorPage'
import Paper from 'material-ui/Paper'
import Spinner from '../../common/Spinner'
import ObjectCard from '../../common/ObjectCard'
import ObjectCardVirtual from '../../common/ObjectCardVirtual'
import { themeColors } from '../../styles/theme'
import NoResults from '../../common/NoResults'
import withTopBar from '../../common/TopBar/withTopBar'

const styles = {
  itemsList: {
    paddingTop: 70,
  },
  topCardText: {
    color: themeColors.energized,
  },
  strongText: {
    color: themeColors.positive,
    fontWeight: 'bold',
  },
  topCard: {
    padding: 15,
    marginBottom: 10,
    backgroundColor: themeColors.lightBackground,
    overflow: 'hidden',
    paddingRight: 15,
    marginLeft: 10,
  },
  GotoICanGetInvitation: {
    textAlign: 'center',
  },
}

const GotoICanGetInvitation = () => (
  <div style={styles.GotoICanGetInvitation}>
    Per vedere quali scambi puoi fare vai sulla tua
    {' '}
    <Link to="/me/items/can-get" style={{ color: themeColors.positive }}>
      "Posso avere"
    </Link>
  </div>
)

class ItemsICanGet extends PureComponent {
  componentDidMount() {
    const { byItemId, location, category, world } = this.props

    if (!isNull(byItemId)) {
      this.props.getItemDetail(
        byItemId,
        {
          user_id: this.props.user.id,
        },
        getLocationKey(location)
      )
    }

    this.props.loadItemsICanGet(
      {
        item_id: byItemId,
        cat_id: category ? category.id : null,
        world_id: world ? world.id : null,
      },
      getLocationKey(location)
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.byItemId !== nextProps.byItemId) {
      // Unload previous item when needed
      if (!isNull(this.props.byItemId)) {
        this.props.unloadItemDetail()
      }
      // Load new item when neeeded
      if (!isNull(nextProps.byItemId)) {
        this.props.getItemDetail(nextProps.byItemId, {
          user_id: nextProps.user.id,
        })
      }
      // Load new stuff of items i can get with or without by item
      this.props.unloadItemsICanGet()
      this.props.loadItemsICanGet({
        item_id: nextProps.byItemId,
        cat_id: nextProps.category ? nextProps.category.id : null,
        world_id: nextProps.world ? nextProps.world.id : null,
      })
    } else if (
      this.props.category !== nextProps.category ||
      this.props.world !== nextProps.world
    ) {
      this.props.unloadItemsICanGet()
      this.props.loadItemsICanGet({
        item_id: nextProps.byItemId,
        cat_id: nextProps.category ? nextProps.category.id : null,
        world_id: nextProps.world ? nextProps.world.id : null,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadItemsICanGet(false)
    if (!isNull(this.props.byItemId)) {
      this.props.unloadItemDetail()
    }
  }

  loadMore = () => {
    this.props.loadMoreItemsICanGet({
      item_id: this.props.byItemId,
      cat_id: this.props.category ? this.props.category.id : null,
      world_id: this.props.world ? this.props.world.id : null,
    })
  }

  goToItemDetail = item => {
    this.props.putItemsICanGetInCache({
      cacheKey: getLocationKey(this.props.location),
    })
    const { byItemId } = this.props
    if (byItemId) {
      this.props.history.push(itemLink(item, byItemId))
    } else {
      this.props.history.push(itemLink(item))
    }
  }

  render() {
    const {
      byItemId,
      byItemLoading,
      byItemError,
      byItem,
      totalItems,
    } = this.props

    if (byItemId) {
      // Items i can get by item

      if (byItemLoading) {
        return <Spinner centered />
      }

      if (byItemError) {
        return <ErrorPage error={byItemError} />
      }

      return (
        <div>
          {byItem &&
            <div>
              <div className="fixed-row-responsive">
                <Paper style={styles.topCard}>
                  <p style={styles.topCardText} className="responsive-text">
                    Puoi scambiare
                    {' '}
                    <span style={styles.strongText}>{byItem.titolo}</span>
                    {' '}
                    con
                    {' '}
                    <span style={styles.strongText}>{totalItems}</span>
                    {' '}
                    oggetti
                  </p>
                </Paper>
              </div>
              <div style={styles.itemsList}>{this.renderItems()}</div>
            </div>}
        </div>
      )
    } else {
      // Simple items i can get
      return this.renderItems()
    }
  }

  renderItems() {
    const { loading, byItem, items, canLoadMoreItems } = this.props

    return (
      <div>
        <ObjectCardVirtual
          items={items}
          loadMore={this.loadMore}
          canLoadMoreItems={canLoadMoreItems}
          loading={loading}
          noContentRenderer={() => (
            <div>
              {!loading &&
                !isNull(items) &&
                <div>
                  <NoResults>
                    Non puoi avere ancora nessun oggetto
                    {' '}
                    {byItem && <span>da "{byItem.titolo}"</span>}
                  </NoResults>
                  {byItem && <GotoICanGetInvitation />}
                </div>}
            </div>
          )}
          renderObjectCard={item => (
            <ObjectCard item={item} onClick={this.goToItemDetail} />
          )}
        />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
  // ~~ Items i can get by this item id, not mandatory
  byItemId: parseQsId(ownProps.location, 'item'),
  byItem: state.itemDetail.item,
  byItemLoading: state.itemDetail.loading,
  byItemError: state.itemDetail.error,
  category: getCategory(state, parseQsArg(ownProps.location, 'category')),
  world: getWorld(state, parseQsArg(ownProps.location, 'world')),
  items: getItemsICanGet(state, getLocationKey(ownProps.location)),
  totalItems: getTotalItemsICanGet(state),
  canLoadMoreItems: canLoadMoreItemsICanGet(state),
  loading: getItemsICanGetLoading(state),
})

export default withTopBar({
  toolbar: 'ItemsICanGetToolbar',
  title: 'Posso avere',
})(
  connect(mapStateToProps, {
    getItemDetail,
    unloadItemDetail,
    loadItemsICanGet,
    loadMoreItemsICanGet,
    unloadItemsICanGet,
    putItemsICanGetInCache,
  })(ItemsICanGet)
)



// WEBPACK FOOTER //
// ./src/pages/Me/ItemsICanGet.js